import { render, staticRenderFns } from "./FriendshipActivity.vue?vue&type=template&id=c184eea0&scoped=true"
import script from "./FriendshipActivity.vue?vue&type=script&lang=ts"
export * from "./FriendshipActivity.vue?vue&type=script&lang=ts"
import style0 from "./FriendshipActivity.vue?vue&type=style&index=0&id=c184eea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c184eea0",
  null
  
)

export default component.exports